import React from 'react';
import { motion } from 'framer-motion';
import { HardHat, FileCheck, Target, Wrench, Quote } from 'lucide-react';
const pillars = [{
  icon: HardHat,
  title: 'Experiencia en obra',
  desc: 'Conocimiento real adquirido en instalaciones residenciales concretas, no solo teoría de manual.'
}, {
  icon: FileCheck,
  title: 'Normativa vigente',
  desc: 'Todo el contenido alineado con la reglamentación eléctrica actual aplicada en Argentina.'
}, {
  icon: Target,
  title: 'Criterio profesional',
  desc: 'Te enseñamos a pensar como electricista, no solo a repetir pasos sin entender el porqué.'
}, {
  icon: Wrench,
  title: 'Aplicación práctica',
  desc: 'Cada concepto teórico se aplica a casos reales que vas a encontrar en cualquier vivienda.'
}];
const testimonials = [{
  quote: 'Aprendí lo que en años de trabajo no había logrado entender. Hoy hago instalaciones con criterio.',
  author: 'Martín G.',
  location: 'Córdoba'
}, {
  quote: 'Empecé desde cero. Hoy tengo mis primeros clientes y trabajo con seguridad técnica.',
  author: 'Lucas R.',
  location: 'Buenos Aires'
}];
export function TrustSection() {
  return <section id="por-que" className="py-24 bg-ed-black relative border-t border-white/5" data-id="element-518">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-519">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-520">
          <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-521">
            Por qué confiar
          </span>
          <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white mb-6" data-id="element-522">
            Formación real. <br className="sm:hidden" data-id="element-523" />
            <span className="text-ed-green" data-id="element-524">Experiencia real.</span>
          </h2>
          <p className="text-zinc-400 text-lg leading-relaxed" data-id="element-525">
            No es contenido reciclado de internet. Es una formación construida
            sobre años de trabajo en obra, criterio profesional y aplicación
            práctica de la normativa vigente en instalaciones residenciales.
          </p>
        </div>

        {/* Pillars */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20" data-id="element-526">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="bg-ed-dark border border-zinc-800 rounded-2xl p-6 hover:border-ed-green/40 transition-all" data-id="element-527">
                <div className="w-12 h-12 rounded-xl bg-ed-green/10 border border-ed-green/30 flex items-center justify-center mb-4" data-id="element-528">
                  <Icon className="w-6 h-6 text-ed-green" data-id="element-529" />
                </div>
                <h3 className="text-white font-black uppercase text-sm tracking-wide mb-2" data-id="element-530">
                  {pillar.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-531">
                  {pillar.desc}
                </p>
              </motion.div>;
        })}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-532">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-ed-dark border border-zinc-800 rounded-2xl p-8 relative" data-id="element-533">
              <Quote className="w-8 h-8 text-ed-green/30 mb-4" data-id="element-534" />
              <p className="text-white text-lg leading-relaxed mb-6" data-id="element-535">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-536">
                <div className="w-10 h-10 rounded-full bg-ed-green/10 border border-ed-green/30 flex items-center justify-center text-ed-green font-black text-sm" data-id="element-537">
                  {t.author.charAt(0)}
                </div>
                <div data-id="element-538">
                  <div className="text-white font-bold text-sm" data-id="element-539">{t.author}</div>
                  <div className="text-zinc-500 text-xs uppercase tracking-wider" data-id="element-540">
                    {t.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}